export default function TwitterX(): JSX.Element {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>X (formerly Twitter)</title>
      <path
        d="M9.86331 7.34219L15.6916 0.567383H14.3105L9.24978 6.44985L5.20782 0.567383H0.545898L6.65814 9.46272L0.545898 16.5671H1.92709L7.27132 10.3551L11.5399 16.5671H16.2018L9.86297 7.34219H9.86331ZM7.97158 9.54109L7.35228 8.65531L2.42476 1.60711H4.54619L8.52276 7.29523L9.14206 8.18101L14.3111 15.5747H12.1897L7.97158 9.54143V9.54109Z"
        fill="currentColor"
      />
    </svg>
  )
}

try{ TwitterX.displayName ||= 'TwitterX' } catch {}